import { useNavigate, useParams } from "react-router-dom";
import FormButton from "../../../Components/Buttons/FormButton";
import CustomizableTableForAddAndEdit from "../../../Components/Tables/CustomizableTableForAddAndEdit";
import PageHeader from "../../../Layout/PageHeader";
import {
  DataFromAPI5,
} from "../../../Data/testData";
import {
  initialData_EditCode,
  dropDownItemCode_bomEdit,
  typeOfKitOptions
} from "../../../Data/BomMaintainanceData";
import FormSelect from "../../../Components/FormTag/FormSelect";
import { useForm } from "react-hook-form";
import Select from "react-select";
import CustomPlaceholder from "../../../Shared/Select/CustomPlaceholder";
import { useEffect } from "react";
import { bomBasicInformationType } from "./Bom.type";
import InputFiled from "../../../Components/FormTag/InputFiled";
import Tabs from "../../../Shared/Tab/Tab";

export default function BomConfigureKitDetailsEdit() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const pageName = `Edit Kit`;
  const {
    control,
    register,
    setValue,
    formState: { errors },
  } = useForm<bomBasicInformationType>({
    defaultValues: new bomBasicInformationType(),
  });

  useEffect(() => {
    setValue('typeOfKit', typeOfKitOptions[0].value);
    setValue('Qty', "1");
  }, [setValue, typeOfKitOptions, initialData_EditCode]);

  const backNavigate = () => {
    return navigate(`/inventory/assembly/kitting/details/${id}`);
  };

  const handleClose = () => {
    backNavigate();
  };
  const customStylesForInvStats = {
    control: (provided: any) => ({
      ...provided,
      width: "130px !important",
      fontSize: "14px",
    }),
    menu: (provided: any) => ({
      ...provided,
      width: "130px",
    }),
  };

  const columns = [
    {
      key: 'itemCode', label: 'Item Code',
      inputType: (
        <Select components={{ Placeholder: CustomPlaceholder }}
          styles={customStylesForInvStats}
          options={dropDownItemCode_bomEdit} />),
      customStyles: { width: "160px" },
      disable: true
    },
    {
      key: "itemDescription",
      label: "Item Description",
      disable: true,
      customStyles: { width: "182px" },
    },
    {
      key: "Qty",
      label: "Qty",
      inputType: (
        <span className="customDropdown">
          <InputFiled
            type="text"
            tabIndex={1}
            register={register}
            name="Qty"
            required={true}
            className=" no-border-on-hover bg-transparent"
            placeholder="_"
          />
        </span>
      ),
      customStyles: { width: "100px" },
    },
  ];

  const tabs = [
    {
      order: 0,
      label: "Basic Information",
      content: (
        <>
        </>
      ),
      visibility: true,
      status: true,
    },
    {
      order: 1,
      label: "Attribute",
      content: (
        <>
        </>
      ),
      visibility: true,
      status: false,
    },
    {
      order: 2,
      label: "Configure Kit",
      content: (
        <>
        </>
      ),
      visibility: true,
      status: false,
    },
    {
      order: 3,
      label: "User defined Field",
      content: (
        <>
        </>
      ),
      visibility: true,
      status: false,
    }
  ];

  return (
    <>
      <PageHeader
        addUrl="/inventory/assembly/kitting/create"
        listUrl="/inventory/assembly/kitting/details/{id}"
        viewType={true}
        isHistoryEnabled={true}
      />
      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <Tabs
          tabs={tabs}
          isCheckbox={true}
          activeTabClass="d-flex flex-column h-100"
          tabLabelClass="d-flex flex-column h-100"
        />
      <div className="my-2 bg-white rounded py-1 px-2">
        <div className="checkin-details col-12 bg-white col-12 py-1 py-4 px-5 ">
          <div className="row">
            <div className="col-2 px-2 mb-3">
              <div>
                <label className="fw-medium">Item Code</label>
              </div>
              <div className="fs-15 mt-1">2332</div>
            </div>
            <div className="col-2 px-2 mb-3">
              <div>
                <label className="fw-medium">Item Description</label>
              </div>
              <div className="fs-15 mt-1">XBOX</div>
            </div>
          </div>

          <div className="row">
            <div className="col-3 px-2 mb-3">
              <label className="fw-medium">Select Type of Kit</label>
              <FormSelect
                name="typeOfKit"
                tabIndex={2}
                control={control}
                optionList={typeOfKitOptions}
                required={true}
                className="form-control p-0 mt-1"
                isSearchable={true}
              />
            </div>
          </div>
        </div>
      </div>
      <h6 className="text-start mb-1">Select Component</h6>
      <div className="my-2 bg-white rounded py-1 px-5 h-100 CustomizedTable ">
        <CustomizableTableForAddAndEdit
          columns={columns}
          initialData={initialData_EditCode}
          customClassName="tranferEditCustomTable"
          dataFromAPI={DataFromAPI5}
          filterColumn="itemCode"
        />
      </div>
      <div className="my-2 bg-white rounded py-3">
        <div className="d-flex flex-row-reverse">
          <FormButton
            tabIndex={25}
            className="sph-btn me-4"
            handleClick={() => handleClose()}
          >
            Submit
          </FormButton>
          <FormButton
            tabIndex={26}
            className="sph-btn sph-shift me-4"
            handleClick={() => handleClose()}
          >
            Cancel
          </FormButton>
        </div>
      </div>
    </>
  );
}
